<odx-menu>
  @if ((isReadOnlyUser$ | async) === false && (isNewProjectVisible$ | async)) {
    <button odxButton odxMenuItem variant="ghost" routerLink="/new-project">
      <odx-icon name="plus" size="medium"></odx-icon>
      <span i18n="@@menu.button.newProject">Neues Projekt</span>
    </button>
  }
  @if ((isReadOnlyUser$ | async) === false) {
    <button odxButton odxMenuItem variant="ghost" (click)="onClickDeleteFromCloud()">
      <odx-icon name="cloud" size="medium"></odx-icon>
      <span i18n="@@menu.button.deleteCloudProjects">Cloudprojekte löschen</span>
    </button>
  }
  @if ((isReadOnlyUser$ | async) === false) {
    <a href="mailto:DLCDE-Navinta@draeger.com" odxButton odxMenuItem variant="ghost">
      <odx-icon name="comment" size="medium"></odx-icon>
      <span i18n="@@menu.button.contactNavintaTeam">Navinta-Team kontaktieren</span>
    </a>
  }
  @if ((isReadOnlyUser$ | async) === false) {
    <button odxButton odxMenuItem variant="ghost" (click)="onClickRefresh()" data-testid="main-menu.update-product-data">
      <odx-icon name="sync" size="medium"></odx-icon>
      <span i18n="@@menu.button.RefreshProductData">Produktdaten aktualisieren</span>
    </button>
  }
  <a odxButton odxMenuItem variant="ghost" [href]="privacyUrl" target="_blank" i18n="@@menu.button.privacyPolicy">
    Datenschutzerklärung
  </a>

  <a odxButton odxMenuItem variant="ghost" [href]="legalNoticeUrl" target="_blank" i18n="@@menu.button.legalNotice">
    Rechtliche Hinweise
  </a>

  <button odxButton odxMenuItem variant="ghost" onClick="UC_UI.showSecondLayer();" i18n="@@menu.button.privacySettings">
    Datenschutzeinstellungen
  </button>
  <a odxButton odxMenuItem variant="ghost" [href]="imprintUrl" target="_blank" i18n="@@menu.button.impressum">Impressum</a>

  @if ((isReadOnlyUser$ | async) === false) {
    <button odxButton odxMenuItem variant="ghost" class="logout" (click)="logOut()">
      <odx-icon name="logout" size="medium"></odx-icon>
      <span i18n="@@menu.button.logout">Abmelden</span>
    </button>
  }

  <div odxButton><img id="logo" src="../../assets/draeger-logo.png" alt="Draeger Logo" /></div>
</odx-menu>
